<template lang="pug">
  div.confirm-layout.w-100.m-2
    div.alert.alert-success 
      span 目前操作藥盒：{{ selectedDevicesID.indexOf(currentDevice.id.toString()) + 1 }} / {{ selectedDevicesID.length }}
    Action(
      v-on:setActionData="getActionData"
      :deviceId="currentDevice.id"
      :defaultNum="fakeNumber"
      :checkNum="fakeNumber"
      :hasSlot="true"
      :valueMoreThanZero="false"
    )
      div.instruction-wrapper(v-if="actionType === 'lock'")
        font-awesome-layers.fa-3x.fa-fw
          font-awesome-icon(:icon="arrowDownIcon" transform="shrink-6 up-10")
          font-awesome-icon(:icon="boxOpenIcon" transform="down-1")
        h4.text-center 請將藥物放入藥盒內
      div.instruction-wrapper(v-if="actionType === 'unlock'")
        font-awesome-layers.fa-3x.fa-fw
          font-awesome-icon(:icon="arrowUpIcon" transform="shrink-6 up-10")
          font-awesome-icon(:icon="boxOpenIcon" transform="down-1")
        h4.text-center 請將藥物自藥盒取出
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { faArrowDown, faArrowUp, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import Action from '../flowComp/Action';

export default {
  name: 'LockBoxConfirmFlow',
  props: ['actionType'],
  data() {
    return {
      fakeNumber: 1,
      emitTime: 0,
    };
  },
  components: {
    Action,
  },
  methods: {
    getActionData(data) {
      if (this.emitTime === 0) {
        if (this.actionType === 'lock') {
          const fakeDrugStorage = {
            device: this.currentDevice.id,
            medication: this.selectedDrug.id,
            max_stock: 1,
            patch_number: this.patchNumber,
            expired_date: moment().format('YYYY-MM-DD'),
            stock: data.num,
            pack_count: 0,
            // min_stock: this.minStorage,
            number1: data.num,
            type: 'LOCKUP', // event type: for event recording
          };
          this.instance.post('/api/drug-storage/', fakeDrugStorage)
          .then((res) => {
            this.$emit('confirmationFinish');
          });
        }

        if (this.actionType === 'unlock') {
          const promises = [];
          this.currentDevice.drugstorage_set.forEach((item) => {
            promises.push(
              this.instance.delete(`/api/drug-storage/${item.id}/`, {
                data: {
                  type: 'UNLOCK',
                },
              }),
            );
          });
          axios.all(promises)
          .then(() => {
            this.$emit('confirmationFinish');
          });
        }
      }
      this.emitTime += 1;
    },
  },
  computed: {
    selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    instance() {
      return this.$store.state.instance;
    },
    arrowDownIcon() {
      return faArrowDown;
    },
    arrowUpIcon() {
      return faArrowUp;
    },
    boxOpenIcon() {
      return faBoxOpen;
    },
    selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
  },
};
</script>

<style lang="sass">
.instruction-wrapper
  display: flex;
  width: 100%

  justify-content: center
  margin-bottom: 30px
  h4
    margin-left: 30px
</style>



// WEBPACK FOOTER //
// ConfirmFlow.vue?a374a7d2